import React from 'react'
import { useSelector } from 'react-redux';
import { USER_ROLES } from '../../utils/constant';
import { useHistory } from 'react-router-dom';

export default function InvFamCheckRoute(): JSX.Element {
    const { role } = useSelector((state: any) => state.auth);
    const { isCustFamilyHead, familyId } = useSelector((state: any) => state.id);
    const history = useHistory();

    if (role === USER_ROLES.INVESTOR && isCustFamilyHead === 'Y') {
        history.replace(`/investor-family/family-profile/${familyId}`);
    }

    else if (role === USER_ROLES.INVESTOR && familyId) {
        history.replace('/investor-family/leaveFamily');
    }
    else if (role === USER_ROLES.INVESTOR && !familyId) {
        history.replace('/investor-family/createFamily');
    }
    return (
        <></>
    )
}
